<template>
  <div class="header">
    <HeaderTop />
    <HeaderTabs />
    <HeaderBanner />
  </div>
</template>

<script>
import HeaderTop from './HeaderTop.vue';
import HeaderTabs from './HeaderTabs.vue';
import HeaderBanner from './HeaderBanner.vue';

export default {
  name: 'Header',
  components: {
    HeaderTop,
    HeaderTabs,
    HeaderBanner,
  },
};
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 1000;
}
</style>